import { Button, ResponsiveSection, Stack, Text } from '@stitch-fix/mode-react';
import type { Ref } from 'react';
import { CloudinaryImageV2 } from '../../../../../components/CSCloudinaryAsset/Image';
import type { BrandsValuePageData } from '../../types';
import styles from './index.module.scss';
interface HeroSectionProps {
  hero: BrandsValuePageData['hero'];
  sectionRef?: Ref<HTMLElement>;
}
const renderTile = (tile: BrandsValuePageData['hero']['columns'][number]['tiles'][number], variant: BrandsValuePageData['hero']['columns'][number]['variant'], index: number, columnIndex: number) => {
  if (tile.kind === 'logo') {
    return <div className={`${styles.logoBox} ${variant === 'wide-stack' ? styles.logoBoxWide : styles.logoBoxNarrow}`} data-testid="hero-logo-box" key={`${tile.imageSrc}-${index}`}>
        {tile.cloudinaryAsset && <CloudinaryImageV2 alt={tile.alt} cloudinaryAsset={tile.cloudinaryAsset} sizes={[{
        minWidth: 0,
        staticWidth: 240
      }]} imageProps={{
        loading: 'lazy',
        style: {
          height: '100%',
          objectFit: 'contain'
        }
      }} />}
        {!tile.cloudinaryAsset && <img alt={tile.alt} className={styles.logoMark} src={tile.imageSrc} />}
      </div>;
  }
  let imageClassName = styles.stackNarrowImage;
  if (variant === 'tall') {
    imageClassName = styles.tall;
  } else if (variant === 'wide-stack') {
    imageClassName = styles.stackWideImage;
  }
  const isPriorityImage = tile.kind === 'image' && columnIndex === 0 && index === 1;
  return <div className={imageClassName} key={`${tile.imageSrc}-${index}`}>
      {tile.cloudinaryAsset && <CloudinaryImageV2 alt="" cloudinaryAsset={tile.cloudinaryAsset} sizes={[{
      minWidth: 0,
      staticWidth: 320
    }]} imageProps={{
      fetchPriority: isPriorityImage ? 'high' : undefined,
      loading: isPriorityImage ? 'eager' : 'lazy',
      style: {
        height: '100%',
        objectFit: 'cover'
      }
    }} />}
      {!tile.cloudinaryAsset && <img alt="" src={tile.imageSrc} />}
    </div>;
};
const renderColumns = (columns: BrandsValuePageData['hero']['columns']) => columns.map((column, columnIndex) => <div className={styles.slide} key={column.id}>
      <div className={styles.column}>
        {column.tiles.map((tile, index) => renderTile(tile, column.variant, index, columnIndex))}
      </div>
    </div>);
export const HeroSection = ({
  hero,
  sectionRef
}: HeroSectionProps) => {
  const columns = renderColumns(hero.columns);
  return <section className={styles.section} ref={sectionRef}>
      <div className={styles.media} aria-hidden="true">
        <div className={styles.mediaInner}>
          <div className={styles.fade} />
          <div className={styles.trackViewport}>
            <div className={styles.track}>
              <div className={styles.trackGroup}>{columns}</div>
              <div className={styles.trackGroup}>{columns}</div>
            </div>
          </div>
        </div>
      </div>

      <ResponsiveSection>
        <div className={styles.content}>
          <div className={styles.textStack}>
            <Stack hAlign={{
            sm: 'start',
            md: 'center'
          }} spacing={1}>
              <Text as="h1" className={styles.title} setting="display-xlarge">
                {hero.title}
              </Text>
              <Text as="p" className={styles.description} setting="body-medium">
                {hero.description}
              </Text>
              <div className={styles.cta}>
                <Button as="a" href={hero.ctaHref} variant="filled-accent-large" width="fit">
                  {hero.ctaLabel}
                </Button>
              </div>
              <Text as="p" className={styles.supportingCopy} setting="body-small-fixed">
                {hero.eyebrow}
              </Text>
            </Stack>
          </div>
        </div>
      </ResponsiveSection>
    </section>;
};